import store from 'utils/store';
import config from 'utils/config';

export function getCanMembersContribute(playlist) {
	const isDistributedPlaylist =
		playlist.domain_id && +store('domainId') !== +playlist.domain_id;
	if (isDistributedPlaylist) {
		return false;
	}
	const canMembersContribute =
		config.memberContributions && playlist.allow_member_contributions;
	return canMembersContribute;
}
